var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7293 10.9999H28.6795C29.1808 11.0161 29.6559 11.2195 30.0044 11.5672C30.353 11.9149 30.5478 12.3797 30.5475 12.8633V23.9939C30.5471 24.111 30.5125 24.2256 30.4475 24.3245C30.3826 24.4234 30.2899 24.5026 30.1803 24.5529C30.0763 24.5974 29.9618 24.6145 29.8487 24.6025C29.7355 24.5905 29.6277 24.5498 29.5362 24.4846L26.4572 22.1802H17.7293C17.2168 22.1802 16.7253 21.9839 16.3629 21.6344C16.0005 21.285 15.7969 20.811 15.7969 20.3168V12.8633C15.7969 12.3691 16.0005 11.8952 16.3629 11.5457C16.7253 11.1963 17.2168 10.9999 17.7293 10.9999ZM13.8648 15.3479V20.3169C13.8648 21.3053 14.272 22.2532 14.9967 22.9521C15.7215 23.651 16.7046 24.0436 17.7296 24.0436H24.815V24.7455C24.8239 24.9808 24.7826 25.2155 24.6937 25.4348C24.6048 25.6542 24.4701 25.8536 24.298 26.0207C24.1259 26.1878 23.9201 26.3191 23.6932 26.4063C23.4664 26.4936 23.2233 26.5351 22.9792 26.5281H14.3221L11.0048 28.8822C10.9127 28.9464 10.8046 28.986 10.6915 28.9969C10.5783 29.0078 10.4642 28.9897 10.3607 28.9443C10.2533 28.8935 10.1626 28.8149 10.0989 28.7173C10.0352 28.6197 10.001 28.5068 10 28.3915V17.2112C10 16.717 10.2036 16.2431 10.566 15.8936C10.9284 15.5442 11.4199 15.3479 11.9324 15.3479H13.8648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.b896a8cad5aee02b7733d26d98ba52db.svg";
export { ForwardRef as ReactComponent };